var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Immutably removes a key from an object
 *
 * @category Object
 * @since v1.0.0
 * @param {T} obj - The object on which to operate
 * @param {string} key - The key to remove
 * @returns {any}
 * @example
 * let obj = { hello: 'world', hi: 'earth' };
 * obj = removeKey(obj, 'hi')   // returns { hello: 'world' }
 * @docgen_example
 * const obj = { hello: 'world', hi: 'earth' };
 * removeKey(obj, 'hi');
 */
export var removeKey = function (obj, key) {
    return Object.keys(obj).reduce(function (o, k) {
        var _a;
        return k !== key ? __assign(__assign({}, o), (_a = {}, _a[k] = obj[k], _a)) : o;
    }, {});
};
